module.exports = __webpack_public_path__ + "img/baozhuang.f1841967.png";